import React, { FC } from 'react';
import { ShoppingCartIcon } from '@lyse-as/formds-react/lib/icon/common';
import { Badge } from '@lyse-as/formds-react';

export interface ItemProps {
  cartItemCount: number;
}

export const Cart: FC<ItemProps> = (props) => {
  const { cartItemCount } = props;

  return (
    <Badge content={cartItemCount} scheme="secondary">
      <ShoppingCartIcon height={32} width={32} />
    </Badge>
  );
};
